import { DateTime } from 'luxon';
import React, { useState } from 'react';
import { Table, Badge, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';

const ProfileTable = ({ profiles, onViewProfile }) => {
  const [expandedColumn, setExpandedColumn] = useState(null);

  const formatDate = dateString => {
    return DateTime.fromISO(dateString).toLocaleString(DateTime.DATETIME_SHORT);
  };

  const formatWalletId = (walletId, isExpanded) => {
    if (!walletId) return '-';
    if (isExpanded) return walletId;
    return `${walletId.slice(0, 4)}...${walletId.slice(-4)}`;
  };

  const renderWalletId = (walletId, columnName) => {
    if (!walletId) return '-';
    const isExpanded = expandedColumn === columnName;

    return (
      <div
        className="cursor-pointer text-primary"
        onClick={() => setExpandedColumn(isExpanded ? null : columnName)}
        style={{ cursor: 'pointer' }}
      >
        {formatWalletId(walletId, isExpanded)}
      </div>
    );
  };

  const renderStatusBadge = status => {
    let variant;
    switch (status) {
      case 'COMPLETED':
        variant = 'success';
        break;
      case 'DECLINED':
        variant = 'danger';
        break;
      default:
        variant = 'warning';
    }
    return (
      <Badge bg={variant} className="text-capitalize">
        {status.toLowerCase().replace('_', ' ')}
      </Badge>
    );
  };

  const renderActionButtons = profile => (
    <div className="d-flex gap-2">
      <OverlayTrigger placement="top" overlay={<Tooltip>Profile ID: {profile.id}</Tooltip>}>
        <Button variant="outline-primary" size="sm" onClick={() => onViewProfile(profile)}>
          <i className="fa fa-eye"></i>
        </Button>
      </OverlayTrigger>
      {/* <Button variant="outline-secondary" size="sm">
        <i className="fa fa-edit"></i>
      </Button>
      <Button variant="outline-danger" size="sm">
        <i className="fa fa-trash"></i>
      </Button> */}
    </div>
  );

  const renderProfileRow = profile => {
    const isSecondaryProfile = !profile.isPrimary;
    const primaryProfile = isSecondaryProfile
      ? profiles.find(p => p.primaryWalletId === profile.primaryWalletId && p.isPrimary)
      : null;

    return (
      <tr key={profile.id} className={isSecondaryProfile ? 'table-light' : ''}>
        <td className="align-middle">
          <i className={`fa fa-${isSecondaryProfile ? 'id-badge' : 'user'} me-2`}></i>
          {isSecondaryProfile ? 'Sub' : 'Main'}
        </td>
        <td className="align-middle">{renderWalletId(profile.walletId, 'wallet')}</td>
        <td className="align-middle">
          {isSecondaryProfile
            ? renderWalletId(primaryProfile?.walletId || profile.primaryWalletId, 'primary')
            : '-'}
        </td>
        <td className="align-middle">{formatDate(profile.createdAt)}</td>
        <td className="align-middle">{renderStatusBadge(profile.status)}</td>
        <td className="align-middle">{renderActionButtons(profile)}</td>
      </tr>
    );
  };

  return (
    <div className="p-4">
      <Table hover responsive>
        <thead>
          <tr>
            <th>Type</th>
            <th>
              Wallet ID
              {expandedColumn === 'wallet' && (
                <i className="fa fa-compress-alt ms-2 text-muted" style={{ fontSize: '0.8em' }} />
              )}
            </th>
            <th>
              Primary Wallet
              {expandedColumn === 'primary' && (
                <i className="fa fa-compress-alt ms-2 text-muted" style={{ fontSize: '0.8em' }} />
              )}
            </th>
            <th>Created At</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>{profiles.map(profile => renderProfileRow(profile))}</tbody>
      </Table>
      <div className="d-flex justify-content-between align-items-center mt-3">
        <div>
          Showing {profiles.length} of {profiles.length} profiles
        </div>
        <nav>
          <ul className="pagination mb-0">
            <li className="page-item disabled">
              <a className="page-link" href="#" tabIndex="-1">
                Previous
              </a>
            </li>
            <li className="page-item active">
              <a className="page-link" href="#">
                1
              </a>
            </li>
            <li className="page-item disabled">
              <a className="page-link" href="#">
                Next
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  );
};

export default ProfileTable;
